'use client';

import { AppBar, Box, Divider, Paper, Stack, Toolbar, Typography } from '@mui/material';
import React from 'react';
// Images
import Image from 'next/image';
import logo from './cardLogo.jpeg'

const FooterInfo = () => {
    return (
        <div>
            <Box sx={{ flexGrow: 1 }}>
                <Divider color="#07b259" sx={{ height:10 }} />
                <AppBar position="static">
                    <Toolbar
                        sx={{
                            m: 1,
                            py: { xs: 2, sm: 1 },
                            flexDirection: { xs: 'column', sm: 'row' },
                            textAlign: { xs: 'center', sm: 'left' },
                        }}
                    >
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="center">
                                <Image src={logo} alt="Logo" width={65} height={67} />
                                <Stack direction="column" alignItems={{ xs: 'center', sm: 'flex-start' }}>
                                    <Typography sx={{ fontSize: { xs: 13, sm: 14 } }}>Corporate Headquarters</Typography>
                                    <Typography sx={{ fontSize: { xs: 13, sm: 14 } }}>11610 ASH STREET, SUITE 200</Typography>
                                    <Typography sx={{ fontSize: { xs: 13, sm: 14 } }}>LEAWOOD, KS 66211</Typography>
                                </Stack>
                            </Stack>
                            <Typography sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }} />
                            <Stack direction="column" alignItems={{ xs: 'center', sm: 'flex-start' }} sx={{ mt: { xs: 1, sm: 0 } }}>
                                <Typography sx={{ fontSize: { xs: 13, sm: 14 } }}>PHONE: 1-800-444-4030</Typography>
                                <Typography sx={{ fontSize: { xs: 13, sm: 14 } }}>EMAIL: cashoutrequests@cimicard.com</Typography>
                            </Stack>
                            <Typography sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }} />
                            <Typography sx={{ fontSize: { xs: 13, sm: 14 }, mt: { xs: 1, sm: 0 } }}>CARD COMPLIANT, LLC COPYRIGHT © {new Date().getFullYear()}</Typography>
                    </Toolbar>
                </AppBar>
                <Divider color="#07b259" sx={{ height:10 }} />
            </Box>
        </div>
    )
}

export default FooterInfo;